"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CounterDisplayWithToggle = exports.ToggleSpan = exports.CounterDisplayContainer = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.CounterDisplayContainer = styled_components_1.default.div.attrs({})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcursor: ", ";\n\tdisplay: inline-block;\n\tpadding: 5px 8px;\n\n\t", "\n\n\tspan {\n\t\tmargin-left: 2px;\n\t\t.tws-i-icon {\n\t\t\tbottom: 1px;\n\t\t\tfont-size: 9px !important;\n\t\t\tposition: relative;\n\t\t}\n\t}\n"], ["\n\tcursor: ", ";\n\tdisplay: inline-block;\n\tpadding: 5px 8px;\n\n\t", "\n\n\tspan {\n\t\tmargin-left: 2px;\n\t\t.tws-i-icon {\n\t\t\tbottom: 1px;\n\t\t\tfont-size: 9px !important;\n\t\t\tposition: relative;\n\t\t}\n\t}\n"])), function (props) { return (props.count > 0 ? "pointer" : "default"); }, function (props) {
    return props.isActive
        ? "\n\t\tbackground-color: #0083a9;\n\t\tborder-radius: 5px;\n\t\tcolor: #FFF;\n\t\t"
        : "";
});
exports.ToggleSpan = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tvertical-align: top;\n"], ["\n\tvertical-align: top;\n"])));
var CounterDisplayWithToggle = /** @class */ (function (_super) {
    __extends(CounterDisplayWithToggle, _super);
    function CounterDisplayWithToggle(props) {
        var _this = _super.call(this, props) || this;
        _this.HandleOnClick = _this.HandleOnClick.bind(_this);
        return _this;
    }
    CounterDisplayWithToggle.prototype.render = function () {
        var displayCount = this.props.count === 0 ? '--' : this.props.count.toString();
        return (React.createElement(exports.CounterDisplayContainer, { count: this.props.count, isActive: this.props.open && this.props.count > 0, onClick: this.HandleOnClick },
            displayCount,
            this.GetDrawerToggle()));
    };
    CounterDisplayWithToggle.prototype.GetDrawerToggle = function () {
        if (this.props.count < 1) {
            return null;
        }
        return this.GetDirectionalArrow();
    };
    CounterDisplayWithToggle.prototype.GetDirectionalArrow = function () {
        return (React.createElement(exports.ToggleSpan, null,
            React.createElement(aon_tws_common_ui_1.Icon, { name: this.props.open ? 'angle-up' : 'angle-down' })));
    };
    CounterDisplayWithToggle.prototype.HandleOnClick = function () {
        if (this.props.count > 0) {
            this.props.onClick(this.props.id);
        }
    };
    return CounterDisplayWithToggle;
}(React.Component));
exports.CounterDisplayWithToggle = CounterDisplayWithToggle;
var templateObject_1, templateObject_2;
